<h1 class="home-page-content-tab-label" *ngIf="(!searchPerformed || (searchPerformed && (noStoresFound || foundStores?.length < 2)))">
  Order Now For Delivery
</h1>

<mat-form-field class="home-page-content-tab-form">
  <input class="home-page-content-tab-form-input"
         matInput
         id="postCodeInput"
         [formControl]="postcodeFormControl"
         placeholder="Enter your postcode to begin"
         maxlength="10"
         autocomplete="off"
         (keyup.enter)="inputPostCode()"
         #PostCodeInput>
</mat-form-field>

<p class="home-page-content-tab-error" *ngIf="errorPostCode">Please enter a valid postcode.</p>

<div class="stores-default-container" *ngIf="searchPerformed && noStoresFound">
  <div class="stores-default-Item-body" *ngIf="shouldRedirect">
    Redirecting <div class="lds-dual-ring"></div>
  </div>
  <div class="stores-default-Item-body" *ngIf="!shouldRedirect">
    Sorry - we don't deliver to your postcode
  </div>
</div>

<button class="home-page-content-tab-button button-action-1"
        [ngClass]="{'tab-button-hasSites': !noStoresFound && searchPerformed && !errorPostCode }"
        (click)="inputPostCode()">
  <div class="home-page-content-tab-button-text">ORDER NOW</div>
</button>

<div class="home-page-content-tab-hasSites" style="display: flex; align-items: center; justify-content:center" *ngIf="loadingStores">
  <div class="lds-dual-ring"></div>
</div>

<div class="home-page-content-tab-hasSites" *ngIf="!noStoresFound && searchPerformed && !errorPostCode && foundStores?.length > 1">
  <div class="home-page-content-tab-hasSites-label"> <mat-icon class="home-page-content-tab-store-item-icon">store</mat-icon> Available Stores</div>

  <div class="flex-row flex-wrap occasion-selector-stores">
    <div class="card flex-column" *ngFor="let store of foundStores" (click)="setSelectedStore(store)">
      <span>{{ store.Name }}</span>
      <span *ngIf="store.Address">{{ store.Address.RoadNum + ' ' + store.Address.RoadName + ' ' + store.Address.Town  }}</span>
      <span *ngIf="store.Address?.Postcode">{{ store.Address.Postcode  }}</span>
      <a [href]="getPhoneNumber(store.Phone)" *ngIf="store.Phone">{{ store.Phone }}</a>
    </div>
  </div>
</div>